import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import api from "../../services/api";
import "../../index.css";
import './Login.css';
import logoImage from '../../img/Logo Branca 2.png';
import eyeOpen from '../../img/icon/Olho.svg';
import eyeClose from '../../img/icon/Olho Fechado.svg';
import AlertMessage from "../../components/Alert";

export default function Login() {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const { email: emailFromUrl } = useParams();
  const [email, setEmail] = useState(emailFromUrl || "");
  const [senha, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [perfil, setPerfil]: any = useState(null);
  const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

  // Verifica a URL e exibe o alerta
  useEffect(() => {
    if (currentLocation.pathname === '/login/cadastro-realizado-reaproveitamento') {
      setAlert({ show: true, message: 'Usuário criado com sucesso!', variant: "success" });
    }
  }, [currentLocation.pathname]); // Executa apenas quando a rota muda

  useEffect(() => {
    const validateToken = async () => {
      try {
        const token = localStorage.getItem('token');

        if (token) {
          const response = await api.get('validate-token', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.data.isValid && perfil?.nivel !== 5 && perfil?.nivel !== 6) {
            navigate('/pgr');
          } else if (perfil?.nivel === 5) {
            return navigate('/documentos');
          } else if (perfil?.nivel === 6) {
              console.log("🚀 ~ validateToken ~ currentLocation:", currentLocation)
              if(currentLocation.pathname === '/login/cadastro-realizado-reaproveitamento'){
              return navigate('/reaproveitar-asos');
            }else{
            return navigate('/asos-assinados');
            }
          }
        }
      } catch (error) {
        navigate('/');
        localStorage.removeItem('token');
      }
    };
    validateToken();
  }, [navigate, perfil]);

  async function login() {
    try {
      const response = await api.post("login", { email, senha });
      const { token } = response.data;
      if (token && token.token) {
        const expirationDate = new Date(token.expires_at);
        const currentDate = new Date();
        if (expirationDate > currentDate) {
          localStorage.setItem("token", token.token);
          const { data: perfil } = await api.get('nivel-acesso');
          setPerfil(perfil);

          if (currentLocation.pathname.includes('/login/reaproveitamento-de-aso')) {
            return navigate('/reaproveitar-asos');
          }

          if (perfil.nivel === 5) return navigate('/documentos');
          if (perfil.nivel === 6) return navigate(currentLocation.pathname === '/login/cadastro-realizado-reaproveitamento' ? '/reaproveitar-asos' : '/asos-assinados');
          return navigate("/pgr");
        } else {
          setError("O token de autenticação expirou. Faça login novamente.");
        }
      } else {
        setError("Credenciais inválidas. Verifique seu e-mail e senha.");
      }
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        setError("E-mail ou senha incorreta.");
      } else {
        setError("Ocorreu um erro ao fazer login. Por favor, tente novamente mais tarde.");
      }
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login">
      <div className="guide-left">
        <div className="tag">
          <img className="logo-branca" src={logoImage} alt="Logo" />
          <div className="seguran-a-do">MEDICINA DO TRABALHO</div>
        </div>
      </div>
      <div className="guide-right">
        <div className="content-login">
          <form className="inside-content" onSubmit={(e) => { e.preventDefault(); login(); }} style={{ padding: '10px' }}>
            <label htmlFor="access" className="access-label">Entrar</label>

            <div className="form-group-auth">
              <label htmlFor="email">DIGITE SEU E-MAIL</label>
              <input
                type="text"
                placeholder="Digite seu e-mail"
                value={email}
                style={{ maxWidth: '100%' }}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group-auth">
              <label htmlFor="pass">DIGITE SUA SENHA</label>
              <div className="pass-auth">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Digite sua senha"
                  value={senha}
                  style={{ width: '470px', maxWidth: '100%' }}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <img
                  className="olhe"
                  src={showPassword ? eyeClose : eyeOpen}
                  onClick={togglePasswordVisibility}
                  alt="Toggle password visibility"
                />
              </div>
            </div>

            <div className="pass-forget">
              <a href="/recuperar-senha">Esqueci minha senha</a>
            </div>

            <div className="btn-content">
              <button className="btn-access" onClick={login}>Entrar</button>
            </div>
            {error && (
              <div className="my-3 text-danger">
                <p className="text-center mb-3">{error}</p>
              </div>
            )}
          </form>
          <div className="register">
            <span>Ainda não tem uma conta?</span> <a href="/new-register">Cadastre-se</a>
          </div>
        </div>
      </div>
      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />
    </div>
  );
}